export const LANG = {
  en: {
    groups: {
      "Personal Details": "Personal Details",
      "Family Details": "Family Details",
      "Contact Details": "Contact Details",
    },
      placeholders: {
        Name: "Enter full name",
        Gender: "Select gender",
        "Date Of Birth": "Select date of birth",
        "Time Of Birth": "Select time of birth",
        "Place Of Birth": "Enter place of birth",
        Height: "Select height",
        Religion: "Enter religion",
        Caste: "Enter caste",
        "Sub-Cast": "Enter sub-caste",
        Rashi: "Select rashi",
        Nakshatra: "Select nakshatra",
        Gotra: "Enter gotra",
        "God Father": "Enter kul devta / god",
        Complexion: "Select complexion",
        "Highest Education": "Enter highest qualification",
        "College Name": "Enter college name",
        "Job/Occupation": "Enter occupation",
        "Annual Income": "Enter annual income",
        "Father's Name": "Enter father's name",
        "Father's Occupation": "Enter father's occupation",
        "Mother's Name": "Enter mother's name",
        "Mother's Occupation": "Enter mother's occupation",
        "Total Brothers": "Enter number of brothers",
        "Total Sisters": "Enter number of sisters",
        "Contact No.": "Enter contact number",
        "Father Contact No.": "Enter father's contact number",
        Address: "Enter full address",
              Hobbies: "Hobbies",
            "Blood Group": "Blood Group",
            "Manglik": "Manglik",
      },
    labels: {
      Name: "Name",
      Gender: "Gender",
      "Date Of Birth": "Date Of Birth",
      "Time Of Birth": "Time Of Birth",
      "Place Of Birth": "Place Of Birth",
      Height: "Height",
      Religion: "Religion",
      Caste: "Caste",
      "Sub-Cast": "Sub-Cast",
      Rashi: "Rashi",
      Nakshatra: "Nakshatra",
      Gotra: "Gotra",
      "God Father": "God Father",
      Complexion: "Complexion",
      "Highest Education": "Highest Education",
      "College Name": "College Name",
      "Job/Occupation": "Job/Occupation",
      "Annual Income": "Annual Income",
      "Father's Name": "Father's Name",
      "Father's Occupation": "Father's Occupation",
      "Mother's Name": "Mother's Name",
      "Mother's Occupation": "Mother's Occupation",
      "Total Brothers": "Total Brothers",
      "Total Sisters": "Total Sisters",
      "Contact No.": "Contact No.",
      "Father Contact No.": "Father Contact No.",
      Address: "Address",

    },

    optionsMap: {},

    fields: {
      include: [],
      exclude: ["God","Gann", "Nadi"],
    },
  },

  hi: {
    groups: {
      "Personal Details": "व्यक्तिगत जानकारी",
      "Family Details": "पारिवारिक जानकारी",
      "Contact Details": "संपर्क",
    },
    placeholders: {
      Name: "पूरा नाम",
      Gender: "लिंग चुनें",
      "Date Of Birth": "जन्म तिथि चुनें",
      "Time Of Birth": "जन्म समय चुनें",
      "Place Of Birth": "जन्म स्थान",
      Height: "ऊंचाई चुनें",
      Religion: "धर्म",
      Caste: "जाति",
      "Sub-Cast": "उपजाति",
      Rashi: "राशि चुनें",
      Nakshatra: "नक्षत्र चुनें",
      Complexion: "रंग चुनें",
      "Highest Education": "शिक्षा",
      "College Name": "कॉलेज का नाम",
      "Job/Occupation": "पेशा",
      "Annual Income": "वार्षिक आय",
      "Father's Name": "पिता का नाम",
      "Father's Occupation": "पिता का व्यवसाय",
      "Mother's Name": "माता का नाम",
      "Mother's Occupation": "माता का व्यवसाय",
      "Total Brothers": "भाइयों की संख्या",
      "Total Sisters": "बहनों की संख्या",
      "Contact No.": "संपर्क नंबर",
      "Father Contact No.": "पिता का नंबर",
      Address: "पूरा पता",
      "Blood Group": "रक्त समूह चुनें",
      "Manglik": "मांगलिक स्थिति चुनें",
      Hobbies: "रुचियां",
      default: "मान"
      },
    labels: {
      Name: "नाम",
      Gender: "लिंग",
      "Date Of Birth": "जन्म तिथि",
      "Time Of Birth": "जन्म समय",
      "Place Of Birth": "जन्म स्थान",
      Height: "ऊंचाई",
      Religion: "धर्म",
      Caste: "जाति",
      "Sub-Cast": "उपजाति",
      Rashi: "राशि",
      Nakshatra: "नक्षत्र",
      Complexion: "रंग",
      "Highest Education": "शिक्षा",
      "College Name": "कॉलेज का नाम",
      "Job/Occupation": "पेशा",
      "Annual Income": "वार्षिक आय",
      "Father's Name": "पिता का नाम",
      "Father's Occupation": "पिता का व्यवसाय",
      "Mother's Name": "माता का नाम",
      "Mother's Occupation": "माता का व्यवसाय",
      "Total Brothers": "भाईयों की संख्या",
      "Total Sisters": "बहनों की संख्या",
      "Contact No.": "संपर्क नंबर",
      "Father Contact No.": "पिता का नंबर",
      Address: "पता",
      "Blood Group": "रक्त समूह",
      "Manglik": "मांगलिक",
      "Hobbies": "रुचियां",
    },

    optionsMap: {
      Male: "पुरुष",
      Female: "महिला",
      "Prefer not to say": "बताना नहीं चाहते",

      "Very Fair": "बहुत गोरा",
      "Fair": "गोरा",
      "Light Neutral": "हल्का गेहुआं",
      "Wheatish": "गेहुआं",
      "Dark": "सांवला",
      "Brown": "भूरा",
      "Dark Brown": "गहरा भूरा",

      "Mesh (Aries)": "मेष",
      "Vrishabh (Taurus)": "वृषभ",
      "Mithun (Gemini)": "मिथुन",
      "Karka (Cancer)": "कर्क",
      "Simha (Leo)": "सिंह",
      "Kanya (Virgo)": "कन्या",
      "Tula (Libra)": "तुला",
      "Vrishchik (Scorpio)": "वृश्चिक",
      "Dhanu (Sagittarius)": "धनु",
      "Makar (Capricorn)": "मकर",
      "Kumbh (Aquarius)": "कुंभ",
      "Meen (Pisces)": "मीन",

      "Ashwini": "अश्विनी",
      "Bharani": "भरणी",
      "Krittika": "कृत्तिका",
      "Rohini": "रोहिणी",
      "Mrigashirsha": "मृगशीर्ष",
      "Ardra": "आर्द्रा",
      "Punarvasu": "पुनर्वसु",
      "Pushya": "पुष्य",
      "Ashlesha": "आश्लेषा",
      "Magha": "मघा",
      "Purva Phalguni": "पूर्व फाल्गुनी",
      "Uttara Phalguni": "उत्तर फाल्गुनी",
      "Hasta": "हस्त",
      "Chitra": "चित्रा",
      "Swati": "स्वाती",
      "Vishakha": "विशाखा",
      "Anuradha": "अनुराधा",
      "Jyeshtha": "ज्येष्ठा",
      "Mula": "मूल",
      "Purva Ashadha": "पूर्वाषाढ़ा",
      "Uttara Ashadha": "उत्तराषाढ़ा",
      "Shravana": "श्रवण",
      "Dhanishtha": "धनिष्ठा",
      "Shatabhisha": "शतभिषा",
      "Purva Bhadrapada": "पूर्व भाद्रपद",
      "Uttara Bhadrapada": "उत्तर भाद्रपद",
      "Revati": "रेवती"
    },

    fields: {
      include: [],
      exclude: ["Gotra", "God Father", "gan", "nadi", "manglik", "God", "Gann", "Nadi"],
    },
  },

  mr: {
    groups: {
      "Personal Details": "वैयक्तिक माहिती",
      "Family Details": "कौटुंबिक माहिती",
      "Contact Details": "संपर्क",
    },
    placeholders: {
      Name: "पूर्ण नाव",
      Gender: "लिंग निवडा",
      "Date Of Birth": "जन्म तारीख निवडा",
      "Time Of Birth": "जन्म वेळ निवडा",
      "Place Of Birth": "जन्म स्थळ",
      Height: "उंची निवडा",
      Religion: "धर्म",
      Caste: "जात",
      "Sub-Cast": "उपजात",
      Gotra: "गोत्र",
      "God Father": "कुलदैवताचे नाव",
      Rashi: "राशी निवडा",
      Nakshatra: "नक्षत्र निवडा",
      Complexion: "वर्ण निवडा",
      Gann: "गण निवडा",
      Nadi: "नाडी निवडा",
      Manglik: "मांगलिक स्थिती निवडा",
      "Highest Education": "शिक्षण ",
      "College Name": "कॉलेजचे नाव ",
      "Job/Occupation": "कंपनी किंवा व्यवसायाचे नाव, पोस्ट",
      "Annual Income": "वेतन/उत्पन्न",
      "Father's Name": "वडिलांचे संपूर्ण नाव",
      "Father's Occupation": "वडिलांचा व्यवसाय/नोकरी",
      "Mother's Name": "आईचे संपूर्ण नाव",
      "Mother's Occupation": "उदा. गृहिणी",
      "Total Brothers": "भावांची संख्या किंवा नावे",
      "Total Sisters": "बहीणींची संख्या किंवा नावे",
      "Contact No.": "संपर्कासाठी मोबाईल नंबर",
      "Father Contact No.": "वडिलांचा मोबाईल नंबर ",
      Address: "संपूर्ण पत्ता",
      Hobbies: "छंद ",
      God: "कुलदैवत ",
      "Blood Group": "रक्त गट निवडा",
      default: "माहिती "
  },
    labels: {
      Name: "नाव",
      Gender: "लिंग",
      "Date Of Birth": "जन्म तारीख",
      "Time Of Birth": "जन्म वेळ",
      "Place Of Birth": "जन्म स्थळ",
      Height: "उंची",
      Religion: "धर्म",
      Caste: "जात",
      "Sub-Cast": "उपजात",
      Gotra: "गोत्र",
      "God Father": "कुल देवता",
      Rashi: "राशी",
      Nakshatra: "नक्षत्र",
      Complexion: "वर्ण",
      Gann: "गण",
      Nadi: "नाडी",
      Manglik: "मांगलिक",
      "Highest Education": "शिक्षण",
      "College Name": "कॉलेज चे नाव",
      "Job/Occupation": "नोकरी / व्यवसाय",
      "Annual Income": "वार्षिक उत्पन्न",
      "Father's Name": "वडिलांचे नाव",
      "Father's Occupation": "वडिलांचे व्यवसाय",
      "Mother's Name": "आईचे नाव",
      "Mother's Occupation": "आईचे व्यवसाय",
      "Total Brothers": "भाऊ / बहिणी",
      "Total Sisters": "एकूण बहिणी",
      "Contact No.": "मोबाईल नंबर",
      "Father Contact No.": "वडिलांचा मोबाईल नंबर",
      Address: "पत्ता",
      Hobbies: "छंद",
      God: "कुलदैवत",
      "Blood Group": "रक्त गट",
    },

    optionsMap: {
      Male: "पुरुष",
      Female: "स्त्री",
      "Prefer not to say": "सांगू इच्छित नाही",

      "Very Fair": "खूप गोरा",
      "Fair": "गोरा",
      "Light Neutral": "फिकट गव्हाळ",
      "Wheatish": "गव्हाळ",
      "Dark": "सावळा",
      "Brown": "तपकिरी",
      "Dark Brown": "गडद तपकिरी",

      "Mesh (Aries)": "मेष",
      "Vrishabh (Taurus)": "वृषभ",
      "Mithun (Gemini)": "मिथुन",
      "Karka (Cancer)": "कर्क",
      "Simha (Leo)": "सिंह",
      "Kanya (Virgo)": "कन्या",
      "Tula (Libra)": "तुळ",
      "Vrishchik (Scorpio)": "वृश्चिक",
      "Dhanu (Sagittarius)": "धनु",
      "Makar (Capricorn)": "मकर",
      "Kumbh (Aquarius)": "कुंभ",
      "Meen (Pisces)": "मीन",
      "Ashwini": "अश्विनी",

      "Bharani": "भरणी",
      "Krittika": "कृत्तिका",
      "Rohini": "रोहिणी",
      "Mrigashirsha": "मृगशीर्ष",
      "Ardra": "आर्द्रा",
      "Punarvasu": "पुनर्वसू",
      "Pushya": "पुष्य",
      "Ashlesha": "आश्लेषा",
      "Magha": "मघा",
      "Purva Phalguni": "पूर्वा फाल्गुनी",
      "Uttara Phalguni": "उत्तर फाल्गुनी",
      "Hasta": "हस्त",
      "Chitra": "चित्रा",
      "Swati": "स्वाती",
      "Vishakha": "विशाखा",
      "Anuradha": "अनुराधा",
      "Jyeshtha": "ज्येष्ठा",
      "Mula": "मूळ",
      "Purva Ashadha": "पूर्वाषाढा",
      "Uttara Ashadha": "उत्तराषाढा",
      "Shravana": "श्रवण",
      "Dhanishtha": "धनिष्ठा",
      "Shatabhisha": "शतभिषा",
      "Purva Bhadrapada": "पूर्व भाद्रपदा",
      "Uttara Bhadrapada": "उत्तर भाद्रपदा",
      "Revati": "रेवती"
    },

    fields: {
      include: [],
      exclude: ["Gender", "Hobbies", "Sub-Cast", "Total Sisters"],
    },
  },
};